'use strict';

module.exports = {
  SETTINGS: 'settings',
  STORAGE: 'storage',
  READINESS: 'readiness_gate',
  COLLECTORS: 'metrics_collectors',
  EVENTS: 'events_publisher'
};


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/context/constants.js
// module id = 730
// module chunks = 10